import { render, staticRenderFns } from "./HistoryComplaint.vue?vue&type=template&id=430d5691&scoped=true&"
import script from "./HistoryComplaint.vue?vue&type=script&lang=js&"
export * from "./HistoryComplaint.vue?vue&type=script&lang=js&"
import style0 from "./HistoryComplaint.vue?vue&type=style&index=0&id=430d5691&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430d5691",
  null
  
)

export default component.exports